import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all roles
export const getRoles = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/roles`);
    return response.data;
  } catch (error) {
    console.error("Error fetching roles:", error.response?.data || error);
    throw error;
  }
};

// GET a single role
export const getRoleById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/roles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching role:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new role
export const createRole = async (roleData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/roles`, roleData);
    return response.data;
  } catch (error) {
    console.error("Error creating role:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing role
export const updateRole = async (id, roleData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/roles/${id}`, roleData);
    return response.data;
  } catch (error) {
    console.error("Error updating role:", error.response?.data || error);
    throw error;
  }
};

// DELETE a role
export const deleteRole = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/roles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting role:", error.response?.data || error);
    throw error;
  }
};
